// extracted by mini-css-extract-plugin
export default {"sectionRow":"HomePage_sectionRow__7qIwj","sectionColumn":"HomePage_sectionColumn__Dk6To"};